import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik, FieldArray, Field } from 'formik'
import { IconTrash } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'
import { FormFieldGrid } from '@/components/forms/FormFieldGrid'
import { updateOrganizationProperties } from '@/reducers/organizations/organization.actions'

export const HotWordsButton = ({ hotWords, organizationId, reloadOrganization, flags }) => {
  const dispatch = useDispatch()

  const handleSubmit = (values) => {
    const filteredHotWords = values.hotWords.filter((item) => item.word && item.word.trim() !== '')
    dispatch(
      updateOrganizationProperties({
        organizationId,
        reloadOrganization,
        hot_words: filteredHotWords,
      })
    )
  }

  // NOTE: no hotwords for demo "multilingual" language
  const languageOptions = [{ value: 'english', label: 'English' }]
  if (flags.allSpanishPlaybookToggle2022) {
    languageOptions.push({ value: 'spanish', label: 'Spanish' })
  }
  if (flags.frenchEnabled) {
    languageOptions.push({ value: 'french', label: 'French' })
  }

  return (
    <BasicModal
      trigger={(handleOpen) => (
        <Button brand onClick={handleOpen} data-testid="manage-hot-words-button-default">
          Manage Hot Words
        </Button>
      )}
      title="Hot Words"
      size="tiny"
    >
      <Formik
        initialValues={{
          // set default language to 'english'
          // some hotwords may have been saved before language was being set
          hotWords: hotWords.map((hotWord) => ({
            word: hotWord.word,
            language: hotWord.language || 'english',
          })),
        }}
        onSubmit={handleSubmit}
      >
        {({ values, submitForm }) => (
          <FieldArray name="hotWords">
            {(arrayHelpers) => (
              <div className="field-stack">
                {values.hotWords.map((hotWordObj, idx) => {
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <FormFieldGrid key={idx}>
                      <FormField span={8}>
                        <Field
                          as={TextInput}
                          name={`hotWords.${idx}.word`}
                          placeholder="Enter hot word"
                        />
                      </FormField>
                      <FormField span={4}>
                        <Field name={`hotWords.${idx}.language`}>
                          {({ field, form }) => (
                            <Select
                              options={languageOptions}
                              value={field.value}
                              onChange={(option) => {
                                form.setFieldValue(field.name, option.value)
                              }}
                              isClearable={false}
                            />
                          )}
                        </Field>
                      </FormField>
                      <Button
                        square
                        critical
                        aria-label="Remove hot word"
                        onClick={() => arrayHelpers.remove(idx)}
                      >
                        <IconTrash />
                      </Button>
                    </FormFieldGrid>
                  )
                })}
                <Button
                  onClick={() => arrayHelpers.push({ word: '', language: 'english' })}
                  disabled={
                    values.hotWords.length > 0 &&
                    values.hotWords[values.hotWords.length - 1].word.trim() === ''
                  }
                >
                  Add Hot Word
                </Button>
                <div className="modal-footer">
                  <Button brand onClick={submitForm}>
                    Save
                  </Button>
                </div>
              </div>
            )}
          </FieldArray>
        )}
      </Formik>
    </BasicModal>
  )
}
